import React from 'react'
import {
    List,
    Edit,
    DateField,
    ReferenceField,
    BooleanField,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
    BooleanInput,
} from 'react-admin'

export const siteSiteEdit = ({ ...props }) => (
    <Edit {...props}>
        <SimpleForm>
            <TextField source="id" />
            <DateField source="created" />
            <DateField source="updated" />
            <BooleanInput source="visible" />
            <TextInput source="name" />
            <TextInput source="url" />
            <TextInput source="description" />
        </SimpleForm>
    </Edit>
)

export const siteSiteList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <DateField source="created" />
                <DateField source="updated" />
                <BooleanField source="visible" />
                <TextField source="name" />
                <TextField source="url" />
                <TextField source="description" />
            </Datagrid>
        </List>
    )
}
